<template>
  <div id="crew-dm-select-box">
    <div>
      <label class="block aisea-text-14-600-black mb-2"
        >{{ label }} <span v-if="required" style="color: red;">*</span></label
      >
      <treeselect
        v-model="selectedData"
        :multiple="false"
        :searchable="false"
        :clearable="false"
        :required="this.required"
        :options="optionsList"
        :defaultOptions="true"
        :placeholder="this.placeholder"
        @select="onChange"
        class="aisea-text-16-400-black"
      />
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { createNamespacedHelpers } from "vuex";

// Store
const { mapGetters: mapGettersOfCrewDataManagement } = createNamespacedHelpers(
  "crewDataManagement"
);

export default {
  props: {
    id: { type: String, required: true },
    label: { type: String, default: "" },
    required: Boolean,
    placeholder: { type: String, default: "選択してください..." },
    optionsType: { type: String, default: null },
    options: { type: Array, default: () => [] },
    value: {
      type: [String, Number, Object],
      default: null,
    },
  },
  components: {
    Treeselect,
  },
  data() {
    return {
      selectedData: this.value,
      optionsList: [],
    };
  },
  watch: {
    value(newValue) {
      this.selectedData = newValue;
    },
  },
  created() {
    this.initializeOptions();
  },
  methods: {
    ...mapGettersOfCrewDataManagement(["getManningVesselsOptions"]),

    async initializeOptions() {
      if (this.optionsType === "manningVessels") {
        this.optionsList = this.getManningVesselsOptions();
      } else {
        this.optionsList = this.options;
      }
    },

    onChange(value) {
      this.$emit("input", { id: this.id, value });
    },
  },
};
</script>
<style lang="scss">
#crew-dm-select-box {
  .vue-treeselect__control {
    border: 1px solid #ccc !important;
  }

  .vue-treeselect__placeholder {
    color: #757575 !important;
  }
}
</style>
